import * as React from 'react';
import { useSelector } from 'react-redux';
import { ApplicationContext } from '../../../reactContext/applicationContext';
import { IReduxState } from '../../../reducers/store';
import { trackMortgageShow } from '../tracking';

export const useTrackIntoView = () => {
  const userId = useSelector((state: IReduxState) => state.user.userId);
  const abGroup = useSelector((state: IReduxState) => state.config.abGroup);
  const { config } = React.useContext(ApplicationContext);

  return React.useCallback(
    (isTeaserShow: boolean) => {
      const soprApiUrl = config.get<string>('soprApi.browserUrl');

      if (!isTeaserShow || !soprApiUrl) {
        return;
      }

      trackMortgageShow({
        abGroup,
        userId,
        isTeaserShow,
        soprApiUrl,
      });
    },
    [abGroup, userId],
  );
};
